module.exports = __webpack_public_path__ + "static/media/shoot1.0689f9f6.wav";